var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.925 31.5067C10.4547 31.5067 8.44507 29.4968 8.44507 27.0265C8.44507 24.5562 10.4547 22.5462 12.925 22.5462C14.2353 22.5462 15.4767 23.1204 16.3311 24.1209L16.3713 24.1682L16.4434 24.1579L22.5769 20.1618L22.5962 20.0579L22.5949 19.9968L22.6016 19.8739L16.3913 15.8073L16.3511 15.8556C15.4767 16.8795 14.2353 17.4531 12.925 17.4531C10.4547 17.4531 8.44507 15.4435 8.44507 12.9735C8.44507 10.5029 10.4547 8.49323 12.925 8.49323C15.3953 8.49323 17.4049 10.5029 17.4049 12.9735C17.4049 13.3158 17.3612 13.6706 17.275 14.0283L17.2634 14.0766L17.2991 14.1281L23.1105 17.9141L23.1656 17.8153C23.9585 16.3995 25.4567 15.52 27.0751 15.52C29.5454 15.52 31.5551 17.5297 31.5551 20C31.5551 22.4703 29.5454 24.4799 27.0751 24.4799C25.4567 24.4799 23.9585 23.6004 23.1656 22.1843L23.1102 22.0852L17.257 25.8992L17.2689 25.9478C17.3612 26.3284 17.4049 26.6835 17.4049 27.0265C17.4049 29.4968 15.3953 31.5067 12.925 31.5067Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.df82fbea0fc26ecc1d58964f318011ea.svg";
export { ForwardRef as ReactComponent };